import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
export const Form = forwardRef(({ children, className = "", ...props }, ref) => {
    return (_jsx("form", { ref: ref, className: `space-y-4 ${className}`, ...props, children: children }));
});
Form.displayName = "Form";
export function FormField({ label, error, required, children, className = "" }) {
    return (_jsxs("div", { className: `space-y-1 ${className}`, children: [label && (_jsxs("label", { className: "block text-sm font-medium text-black", children: [label, required && _jsx("span", { className: "ml-1 text-red-500", children: "*" })] })), children, error && (_jsx("p", { className: "text-sm text-red-600", role: "alert", children: error }))] }));
}
export const Input = forwardRef(({ className = "", error, ...props }, ref) => {
    const baseClasses = "w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300";
    const errorClasses = error ? "border-red-500" : "border-gray-300";
    return _jsx("input", { ref: ref, className: `${baseClasses} ${errorClasses} ${className}`, ...props });
});
Input.displayName = "Input";
export const Textarea = forwardRef(({ className = "", error, ...props }, ref) => {
    const baseClasses = "w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 resize-vertical";
    const errorClasses = error ? "border-red-500" : "border-gray-300";
    return _jsx("textarea", { ref: ref, className: `${baseClasses} ${errorClasses} ${className}`, ...props });
});
Textarea.displayName = "Textarea";
export const Select = forwardRef(({ className = "", error, options, placeholder, ...props }, ref) => {
    const baseClasses = "w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 bg-white";
    const errorClasses = error ? "border-red-500" : "border-gray-300";
    return (_jsxs("select", { ref: ref, className: `${baseClasses} ${errorClasses} ${className}`, ...props, children: [placeholder && (_jsx("option", { value: "", disabled: true, children: placeholder })), options.map((option) => (_jsx("option", { value: option.value, children: option.label }, option.value)))] }));
});
Select.displayName = "Select";
